import { Chara } from "../types/Dict"
import { useContext } from "react"
import { dictContext } from "../App"

export const PhunChara = (props: {children: string}) => {
    const dict = useContext(dictContext)
    const fontRank = ["psans", "pdot", "pwrite"]

    const dictEntry = dict.find(e => e.chara == props.children)
    if (!dictEntry) { return <span className="serif">{props.children}</span>} //辞書に存在しない時

    for (const f of fontRank) {
        if (dictEntry.support.includes(f)) {
            return <span className={f}>{props.children}</span>
        }
    }

    return <span className="serif">{props.children}</span> //どのフォントも対応していない時
}